import { RootState } from 'store';

export const getParcelType = (state: RootState) => state.estimate.parcelType;
export const getOrderQuantity = (state: RootState) =>
  state.estimate.orderQuantity;
export const getReplacementPercentage = (state: RootState) =>
  state.estimate.replacementPercentage;

export const getImpact = (state: RootState) =>
state.estimate.impact;